<template>
<div class="page_smart_park">
    <div class="container">
        <div class="shop">
            <div class="item" v-for="item in dataList" :key="item.id" @click="toAppoint(item)">
                <van-image class="thumb" fit="cover" :src="item.thumb ? imageUrl+item.thumb : $publicData.defalutFengmian" :show-error="false" :show-loading="false" />
                <div class="title">{{ item.title }}</div>
                <div class="desc">{{ item.descript }}</div>
            </div>
            <!-- <div class="item">
                <van-image class="thumb" fit="cover" :src="publicPath+'statics/images/temp/tu01.png'" />
                <div class="title">天津时代记忆体验馆</div>
                <div class="desc">瞻仰历史伟人，追忆峥嵘岁月——时代记忆《共和国故事：两弹一星大国丰碑展》将于十月一当天正式开展</div>
            </div> -->
        </div>
    </div>
</div>
</template>

<script>
import router from "../../../.././router";
import {
    LOGOUT,
    LOGIN
} from "../../../.././vuex/mutation_types";
import PageSearch from "../../../component/search/Index.vue";
import Vue from "vue";
import Bridge from "../../../.././vuex/bridge.js";
Vue.prototype.$bridge = Bridge;
var userAgent = navigator.userAgent;

export default {
    name: "smart-park",
    data() {
        return {
			imageUrl: this.$publicData.uploadImage,
            publicPath: process.env.BASE_URL,
			id: this.$route.query.id, // 园区id
			dataList: null
        };
    },
    components: {
        PageSearch,
    },
    created: function () {
        //根据userAgent判断是否在iOSAndroid客户端中，隐藏原生导航栏
        if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
            var params = {
                data: {
                    // hiddenNavi: true,
                    naviTitle: '园区场馆',
                }
            };
            this.$bridge.callhandler("sdjy://navigation/style", params, (data) => {});
            //获取用户信息
            var memberParams = {
                data: {
                    notCallLogin: 1,
                },
            };
            this.$bridge.callhandler(
                "sdjy://member/memberInfo",
                memberParams,
                (data) => {
                    if (data.code == 200) {
                        this.token = data.result.token;
                        
                    } else {
                        this.token = "";
                    }
                    this.getData()
                    // 调用某方法
                }
            );
            //注册方法，客户端重新进入页面刷新数据
            this.$bridge.registerhandler(
                "sdjy://common/refreshPage",
                (data, responseCallback) => {
                    // alert(JSON.stringify(data));
                    responseCallback(data);
                }
            );
        } else {
            this.token = this.$store.getters.token;
            this.getData()
        }
		// 展馆列表
		
        // 调起 获取微信分享参数函数 -- 弃用,改成统一配置的
        // this.getShareData()
    },
    methods: {
		// 展馆列表
		getData(){
			var that = this
			var params = {
				id: that.id
			}
			that.$api.smartpark.venuelist(params).then(res=>{
				if(res.code == 200){
					that.dataList = res.result
				}
			})
		},
		// 去单个馆, 预约
		toAppoint(item){
			var that = this
            if (userAgent && userAgent.indexOf("shidaijiyi") != -1) {
                var params = {
					'data': {
						'url': that.$publicData.clientUrl + '/smart/park/appoint?venue_id='+item.id
						}
					}
				that.$bridge.callhandler('sdjy://public/openNewWebView', params, (data) => {

				})
            } else {
                that.$router.push({
                    path: '/smart/park/appoint',
                    query: {
                        venue_id: item.id
                    }
                })
            }
			
		},
        // 获取分享参数 -- 用于配微信分享
        getShareData() {
            const url = location.href.split('#')[0];
            console.log('url', url)
            this.$api.index.commonShare({
                url: url
            }).then(res => {
                if (res.code == 200) {
                    this.shareConfig = res.result
                    // console.log('this.shareConfig', this.shareConfig)
                    // console.log('this.$route', this.$route)
                    this.shareFun()
                }
            })
        },
        // 分享
        shareFun() {
            var that = this
            wx.config({
                debug: that.shareConfig.debug,
                beta: that.shareConfig.beta,
                jsApiList: that.shareConfig.jsApiList,
                appId: that.shareConfig.appId,
                nonceStr: that.shareConfig.nonceStr, // 随机串
                timestamp: parseInt(that.shareConfig.timestamp), // 时间戳
                signature: that.shareConfig.signature // 签名
            });
            // 分享
            wx.ready(function () {
                const url = location.href.split('#')[0];
                var shareData = {
                    title: '时代记忆商城', // 分享标题
                    desc: '时代记忆', // 分享描述
                    link: url, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                    imgUrl: that.$publicData.domain + that.$publicData.logo, // 分享图标
                    success: function () {
                        // 用户确认分享后执行的回调函数
                        // alert('成功')
                    },
                    cancel: function (e) {
                        // alert(e)
                        // 用户取消分享后执行的回调函数
                    }
                }
                wx.updateAppMessageShareData(shareData);
                wx.updateTimelineShareData(shareData);
            });
        }
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped></style>
